import { DeviceType } from 'device-detector-js/dist/typings/device';

export function getHeaderValue<T>(rawValue: T | T[] | undefined) {
  if (Array.isArray(rawValue)) {
    return rawValue[0];
  }
  return rawValue;
}

export function isURL(str: string) {
  let result;

  try {
    new URL(str);
    result = true;
  } catch {
    result = false;
  }

  return result;
}

export function getDomainFromHeader(host: string) {
  if (host.includes('localhost')) {
    return 'localhost';
  }
  if (host.includes('lmru.tech')) {
    return '.lmru.tech';
  }
  if (host.includes('lemanapro.ru')) {
    return '.lemanapro.ru';
  }
  return host;
}

export type ReturnValueDeviceType = 'mobile' | 'tablet' | 'desktop';

export function mapDeviceTypeToStandard(deviceType: DeviceType): ReturnValueDeviceType {
  switch (deviceType) {
    case 'smartphone':
    case 'portable media player':
    case 'feature phone':
      return 'mobile';
    case 'tablet':
    case 'phablet':
      return 'tablet';
    case 'desktop':
    default:
      return 'desktop';
  }
}
